module.exports = __webpack_public_path__ + "img/who-can-help.026e2ecb.png";